var $61d6a54fe0f4cb76$exports = {};
$61d6a54fe0f4cb76$exports = {
    "collectionLabel": `\u{41F}\u{440}\u{43E}\u{43F}\u{43E}\u{437}\u{438}\u{446}\u{456}\u{457}`
};


export {$61d6a54fe0f4cb76$exports as default};
//# sourceMappingURL=uk-UA.module.js.map
